import React, { Component } from "react";
import { HeaderClass, Footer } from "../../components";
import { useLocation, useNavigate } from "react-router-dom";
import styles from "./Item.module.css";
import { Pagination, Breadcrumb } from "antd";
import axios from "axios";
import { Spin } from "antd";
import DIAN from "../../assets/dian.png";

const withItem = (Children: any) => {
  return (props: any) => {
    const loaction = useLocation();
    const navigate = useNavigate();
    return <Children {...props} loaction={loaction} navigate={navigate} />;
  };
};

class ItemComponent extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      arrList: [],
      total: 20,
      page: 1,
      size: 10,
      isLoading: true,
      arr1: [],
      arr2: [],
      id: "",
    };
  }

  itemRender = (current: any, type: any, originalElement: any) => {
    if (type === "prev") {
      return <a>上一页</a>;
    }
    if (type === "next") {
      return <a>下一页</a>;
    }
    return originalElement;
  };

  async componentDidMount() {
    window.scrollTo(0, 0);
    const { page, size } = this.state;
    this.getDataList(page, size);
    try {
      let data = {
        articleListType: 2,
      };
      const currentSessionId =
        window.sessionStorage.getItem("currentSessionId") || "";
      const res = await axios.get(
        "/api/article/page",
        {
          headers: {
            currentSessionId,
          },
          params: data,
        }
      );

      this.setState({
        arr1: res.data.data,
        isLoading: false,
      });
    } catch (error) {
      alert(error);
      this.setState({ isLoading: false });
    }
    try {
      let data = {
        articleListType: 1,
      };
      const currentSessionId =
        window.sessionStorage.getItem("currentSessionId") || "";
      const res = await axios.get(
        "/api/article/page",
        {
          params: data,
          headers: {
            currentSessionId,
          },
        }
      );

      this.setState({
        arr2: res.data.data,
        isLoading: false,
      });
    } catch (error) {
      alert(error);
      this.setState({ isLoading: false });
    }
  }

  getDataList = async (page: any, size: any) => {
    const type = this.props.loaction.state;
    const { obj, isLoading, error } = this.state;
    let id = null;
    if (type === null) {
      id = decodeURIComponent(
        this.props.loaction.pathname.split("/")[
          this.props.loaction.pathname.split("/").length - 1
        ]
      );
    } else {
      id = this.props.loaction.state.id;
    }

    try {
      let data = {
        page: page,
        size: size,
        type: id,
      };
      const currentSessionId =
        window.sessionStorage.getItem("currentSessionId") || "";
      // const res = await apiGet('/api/article/page', {params:data}, null, null)
      const res = await axios.get(
        "/api/article/page",
        {
          headers: {
            currentSessionId,
          },
          params: data,
        }
      );

      this.setState({
        arrList: res.data.data,
        total: res.data.recordsTotal,
        page,
        size,
        isLoading: false,
        id,
      });
    } catch (error) {
      alert(error);
      this.setState({ isLoading: false });
    }
  };

  componentWillReceiveProps(nextProps: any) {
    window.location.reload();
  }

  onChange = (page: any, pageSize: any) => {
    this.getDataList(page, pageSize);
  };

  goToDetails(id: any) {
    const { navigate } = this.props;
    return () => {
      navigate(`/details/${id}`, {
        state: { id: id, text: "" },
      });
    };
  }
  render() {
    const { arrList, total, page, size, isLoading, id, arr1, arr2 } =
      this.state;
    const { navigate } = this.props;

    if (isLoading)
      return (
        <Spin
          tip="Loading..."
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "500px",
          }}
        ></Spin>
      );
    if (!isLoading && id === "专委会简介")
      return (
        <div
          onClick={navigate(`/details/${arrList[0].id}`, {
            state: { id: arrList[0].id, text: "" },
          })}
        >
          {arrList[0].id}
        </div>
      );
    if (!isLoading)
      return (
        <>
          <HeaderClass />
          <div className={styles["w"]}>
            <Breadcrumb
              separator=""
              className={styles["Breadcrumb"]}
              style={{ marginTop: "20px", fontSize: "15px", color: "#000" }}
            >
              <Breadcrumb.Item>当前位置</Breadcrumb.Item>
              <Breadcrumb.Separator>
                {" "}
                &nbsp;&nbsp;&nbsp;&nbsp;
              </Breadcrumb.Separator>
              <Breadcrumb.Item href="" onClick={() => navigate("/")}>
                首页
              </Breadcrumb.Item>
              <Breadcrumb.Separator> &gt; </Breadcrumb.Separator>

              <Breadcrumb.Item href="">
                {this.props.loaction.state !== null
                  ? this.props.loaction.state.id
                  : ""}
              </Breadcrumb.Item>
            </Breadcrumb>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div style={{ width: "750px" }}>
                <div className={styles["title"]}>
                  <div></div>
                  <div
                    style={{
                      background: "#00508B",
                      color: "#fff",
                      padding: "8px 25px",
                      borderTopLeftRadius: "10px",
                      borderTopRightRadius: "10px",
                      fontWeight: 500,
                      fontSize: "14px",
                      marginBottom: "-1px",
                    }}
                  >
                    {this.props.loaction.state !== null
                      ? this.props.loaction.state.id
                      : ""}
                  </div>
                </div>
                {arrList.map((item: any) => {
                  return (
                    <div
                      className={styles["item"]}
                      style={{ cursor: "pointer" }}
                      key={item.id}
                      onClick={() =>
                        navigate(`/details/${item.id}`, {
                          state: {
                            id: item.id,
                            text: this.props.loaction.state.id,
                          },
                        })
                      }
                    >
                      <div className={styles["left"]}>
                        <img src={item.img} alt="" />
                      </div>
                      <div
                        className={styles["right"]}
                        style={{ margin: "0 0 0 20px" }}
                      >
                        <div
                          className={styles["right_title"]}
                          style={{ color: item.color }}
                        >
                          {item.title}
                        </div>
                        <div className={styles["time"]}>
                          <div>{item.articleTypeName}</div>
                          <div>{item.createTime}</div>
                        </div>
                        <div className={styles["desc"]}>
                          {item.shortContent}
                        </div>
                      </div>
                    </div>
                  );
                })}
                <div className={styles["pagination"]}>
                  <Pagination
                    onChange={this.onChange}
                    pageSize={size}
                    current={page}
                    total={total}
                    itemRender={this.itemRender}
                  />
                </div>
              </div>
              <div style={{ marginTop: "18px" }}>
                <div
                  style={{
                    width: "300px",
                  }}
                >
                  <div
                    style={{
                      width: "100px",

                      background: "#005998",
                      color: "#fff",
                      padding: " 5px 10px",
                      borderBottom: "1px solid #005998",
                      borderTopRightRadius: "10px",
                      borderTopLeftRadius: "10px",
                      textAlign: "center",
                    }}
                  >
                    热点新闻
                  </div>
                  <div
                    style={{
                      height: "330px",
                      border: "1px solid #999",
                      borderTop: "3px solid #005998",
                      padding: "5px 15px",
                    }}
                  >
                    {arr1.slice(0, 8).map((item: any, index: any) => {
                      return (
                        <div
                          className="bhf2_fjo"
                          key={item.id}
                          onClick={this.goToDetails(item.id)}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            borderBottom:
                              index === arr1.length - 1 ? "" : "1px solid #999",
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                            padding: "8px 0",
                            color: "#000",
                            fontSize: "13px",
                            cursor: "pointer",
                          }}
                        >
                          <img width={8} height={8} src={DIAN} alt="" />
                          <span style={{ marginLeft: "10px" }}>
                            {item.title}
                          </span>
                        </div>
                      );
                    })}
                  </div>
                </div>
                <div
                  style={{
                    width: "300px",
                    marginTop: "20px",
                  }}
                >
                  <div
                    style={{
                      width: "100px",

                      background: "#005998",
                      color: "#fff",
                      padding: " 5px 10px",
                      borderBottom: "1px solid #005998",
                      borderTopRightRadius: "10px",
                      borderTopLeftRadius: "10px",
                      textAlign: "center",
                    }}
                  >
                    最新动态
                  </div>
                  <div
                    style={{
                      height: "330px",
                      border: "1px solid #999",
                      borderTop: "3px solid #005998",
                      padding: "5px 15px",
                    }}
                  >
                    {arr2.slice(0, 8).map((item: any, index: any) => {
                      return (
                        <div
                          className="bhf2_fjo"
                          key={item.id}
                          onClick={this.goToDetails(item.id)}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            borderBottom:
                              index === arr1.length - 1 ? "" : "1px solid #999",
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                            padding: "8px 0",
                            color: "#000",
                            fontSize: "13px",
                            cursor: "pointer",
                          }}
                        >
                          <img width={8} height={8} src={DIAN} alt="" />
                          <span style={{ marginLeft: "10px" }}>
                            {item.title}
                          </span>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </>
      );
  }
}

export const Item = withItem(ItemComponent);
